export default __webpack_public_path__ + "static/media/home-shop-modern-banner-2.b7e722f5.jpg";